import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { useApolloClient } from "react-apollo";

import ReactSelectAsync from "react-select/async";
import { Field, Control, Label } from "rbx";

import { ALL_INVENTORY_STORAGE_DIMS_QUERY } from "../../graphql/InventoryStorageDims/InventoryStorageDims.graphql";

import { ourToast as toast } from "../../utils";

const InventoryStorageDimSelect = ({
  label,
  size,
  name,
  onChange,
  disabled,
  CompanyLocRecIdRef,
  InvStorageDimRecIdRef,
  Filters,
  value
}) => {
  const client = useApolloClient();
  const [isLoading, setLoading] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [lastFilters, setLastFilters] = useState(null);

  const loadDefaultOptions = useCallback(async () => {
    try {
      setLoading(true);
      const where = {
        Active: true,
        InvStorageDimRecIdRef: parseInt(InvStorageDimRecIdRef)
      };
      if (CompanyLocRecIdRef) {
        where.CompanyLocRecIdRef = parseInt(CompanyLocRecIdRef);
      }

      if (Filters) {
        if (Filters) {
          const {
            InvDim1RecIdRef_in,
            InvDim2RecIdRef_in,
            InvDim3RecIdRef_in
          } = Filters;
          if (InvDim1RecIdRef_in) {
            where.RecId_in = InvDim1RecIdRef_in;
          }
          if (InvDim2RecIdRef_in) {
            where.RecId_in = InvDim2RecIdRef_in;
          }
          if (InvDim3RecIdRef_in) {
            where.RecId_in = InvDim3RecIdRef_in;
          }
        }
      }

      if (
        (Filters &&
          where.RecId_in &&
          Array.isArray(where.RecId_in) &&
          where.RecId_in.length > 0) ||
        !Filters
      ) {
        const { data, loading } = await client.query({
          query: ALL_INVENTORY_STORAGE_DIMS_QUERY,
          variables: {
            where,
            orderBy: "DimCode_ASC",
            orderByMulti: ["DimCode_ASC"]
          },
          refetchQueries: ["ALL_INVENTORY_STORAGE_DIMS_QUERY"]
        });
        setLoading(loading);
        if (!loading && data && Array.isArray(data.InventoryStorageDims)) {
          const grouped = data.InventoryStorageDims.map(currentStorageDim => ({
            value: currentStorageDim.RecId,
            name,
            label: currentStorageDim.DimCode
          }));
          setDefaultOptions([
            {
              value: "0",
              name,
              label: "Select..."
            },
            ...grouped
          ]);
        }
      } else {
        setDefaultOptions([]);
      }
    } catch (err) {
      toast.error("Error getting Inventories Storage Dimension.");
    } finally {
      setLoading(false);
    }
  }, [CompanyLocRecIdRef, Filters, InvStorageDimRecIdRef, client, name]);

  useEffect(() => {
    if (JSON.stringify(Filters) === JSON.stringify(lastFilters)) {
      setLastFilters(Filters);
      loadDefaultOptions();
    } else {
      loadDefaultOptions();
    }
  }, [Filters, lastFilters, loadDefaultOptions]);

  const loadingOptions = useCallback(
    async inputValue =>
      new Promise(async resolve => {
        try {
          setLoading(true);
          const where = {
            Active: true,
            InvStorageDimRecIdRef: parseInt(InvStorageDimRecIdRef)
          };
          if (CompanyLocRecIdRef) {
            where.CompanyLocRecIdRef = parseInt(CompanyLocRecIdRef);
          }

          if (Filters) {
            if (Filters) {
              const {
                InvDim1RecIdRef_in,
                InvDim2RecIdRef_in,
                InvDim3RecIdRef_in
              } = Filters;
              if (InvDim1RecIdRef_in) {
                where.RecId_in = InvDim1RecIdRef_in;
              }
              if (InvDim2RecIdRef_in) {
                where.RecId_in = InvDim2RecIdRef_in;
              }
              if (InvDim3RecIdRef_in) {
                where.RecId_in = InvDim3RecIdRef_in;
              }
            }
          }

          if (
            (Filters &&
              where.RecId_in &&
              Array.isArray(where.RecId_in) &&
              where.RecId_in.length > 0) ||
            !Filters
          ) {
            const { data, loading } = await client.query({
              query: ALL_INVENTORY_STORAGE_DIMS_QUERY,
              variables: {
                where,
                orderBy: "DimCode_ASC",
                orderByMulti: ["DimCode_ASC"]
              },
              refetchQueries: ["ALL_INVENTORY_STORAGE_DIMS_QUERY"]
            });
            if (!loading && data && Array.isArray(data.InventoryStorageDims)) {
              const grouped = data.InventoryStorageDims.map(
                currentStorageDim => ({
                  value: currentStorageDim.RecId,
                  name,
                  label: currentStorageDim.DimCode
                })
              );
              const arrayFilter = grouped.filter(i =>
                i.label.toLowerCase().includes(inputValue.toLowerCase())
              );
              resolve([
                {
                  value: "0",
                  name,
                  label: "Select..."
                },
                ...arrayFilter
              ]);
            } else {
              resolve([]);
            }
          }
        } catch (err) {
          toast.error("Error getting Inventories Storage Dimension.");
        } finally {
          setLoading(false);
        }
      }),
    [CompanyLocRecIdRef, Filters, InvStorageDimRecIdRef, client, name]
  );
  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control size={size}>
        <ReactSelectAsync
          cacheOptions={false}
          defaultOptions={defaultOptions}
          isDisabled={disabled || defaultOptions.length === 0}
          isLoading={isLoading}
          loadOptions={loadingOptions}
          value={value}
          onChange={onChange}
        />
      </Control>
    </Field>
  );
};

InventoryStorageDimSelect.propTypes = {
  value: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  Filters: PropTypes.object,
  CompanyLocRecIdRef: PropTypes.number,
  InvStorageDimRecIdRef: PropTypes.number
};
export default InventoryStorageDimSelect;
